(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/analytics-virtualpage/assets/javascripts/pushstate-virtual.js') >= 0) return;  svs.modules.push('/components/components/analytics-virtualpage/assets/javascripts/pushstate-virtual.js'); 
if (svs.utils.ns.isNamespace('svs.components.analytics.trackVirtual')) {
  var analytics = svs.components.analytics;
  if (typeof history.pushState === 'function') {
    var originalPushState = history.pushState;
    history.pushState = function(state) {
      originalPushState.apply(this, arguments);
      if(state !== null && typeof state === 'object' && state.silent === true) {
        return;
      }
      setTimeout(analytics.trackVirtual, 0);
    };
  }
  if (typeof history.replaceState === 'function') {
    var originalReplaceState = history.replaceState;
    history.replaceState = function(state) {
      var hrefBefore = document.location.href;
      originalReplaceState.apply(this, arguments);
      if (document.location.href !== hrefBefore) {
        if(state !== null && typeof state === 'object' && state.silent === true) {
          return;
        }
        setTimeout(analytics.trackVirtual, 0);
      }
    };
  }

  window.onpopstate = function() {
    setTimeout(analytics.trackVirtual, 0);
  };
}

 })(window);